import { Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '../../../../_service/message-service';
import { Observable, Subscription } from 'rxjs';
import { startWith } from 'rxjs/operators';
import { ConnectorStatus, ConnetorColorCodes } from 'src/app/modules/ocpp/enums/connector.enum';
import { ChargeBoxService } from 'src/app/_services/chargebox/chargebox.service';
import { StationService } from 'src/app/_services/station.service';
import { DeviceStatus } from './status.enum';
import { MenuRouteID } from 'src/app/components/header/menu-item/nav-item';
import { Permission } from 'src/app/util/enums/permission.enum';
import { UserInfoService } from 'src/app/_services/userInfo.service';
import { TariffManagementService } from 'src/app/components/tariff-management/services/tariff-management-service';
import {  TableColumn } from 'src/app/shared/interfaces';
import { MatDialog } from '@angular/material/dialog';

export interface tariffDataDetails {
  id: number;
  country_code: string;
  vendor_id: string;
  currency: string;
  type: string;
  name: string;
  subid: number;
  start_time: string;
  end_time: string;
  subtype: string;
  tax: string;
  price: number;
  step_size: number;
  day_of_week: string[];
  tariff_detail: [];
}
export interface tariffData {
  id: number;
  country_code: string;
  vendor_id: string;
  currency: string;
  type: string;
  name: string;
  vendor_name: string;
  tariff_detail: {
    start_time: string;
    end_time: string;
    type: string;
    tax: string;
    price: number;
    step_size: number;
    day_of_week: string[];
  }[];
}

@Component({
  selector: 'telio-device-spec',
  templateUrl: './device-spec.component.html',
  styleUrls: ['./device-spec.component.scss']
})
export class DeviceSpecComponent implements OnInit, OnDestroy {
  @ViewChild('viewProfile', { static: false }) viewProfile: TemplateRef<any>;
  @Input() stationdetail: any;
  @Input() stationId : any;
  statusSubs: Subscription = new Subscription;
  @Input() bootDetail: any;
  @Input() routeID = null;
  tcolumns: TableColumn[];
  tariffData: tariffData[];
  tariffDataDetails: tariffDataDetails[];
  tariffTableData = [];
  variableType;
  energyType;
  totalDataCountDetail = 0;
  initialDataId: any;

  constructor(readonly router: Router,
    private stationService: StationService,public dialog: MatDialog, readonly toasterService: SnackbarService, readonly translate: TranslateService, private chargeBoxService: ChargeBoxService,
    readonly userInfoService: UserInfoService,private tariffService: TariffManagementService, private toastr: SnackbarService,) {
  }

  ngOnInit(): void {
    this.getStatusNotification(this.stationId);
  }

  getClassByStatus(value: string) {
    switch (value.toLocaleLowerCase()) {
      case DeviceStatus.AVAILABLE: return 'clr_available';
      case DeviceStatus.PREPARING: return 'clr_preparing';
      case DeviceStatus.CHARGING: return 'clr_charging';
      case DeviceStatus.SUSPENDEDEVSE: return 'clr_suspendedevse';
      case DeviceStatus.SUSPENDEDEV: return 'clr_suspendedev';
      case DeviceStatus.FINISHING: return 'clr_finishing';
      case DeviceStatus.RESERVED: return 'clr_reserved';
      case DeviceStatus.UNAVAILABLE: return 'clr_unavailable';
      case DeviceStatus.FAULTED: return 'clr_faulted';
    }
  }

  editStationIs(station, stationId) {
    let objToSend: NavigationExtras = {
      queryParams: {
        "routedName": 'deviceSpec',
        "stationId": stationId,
        "vendorId": station.vendorId
      },
      skipLocationChange: true
    };
    this.router.navigate(["/dashboard/add-station", { routeID: MenuRouteID.STATIONS }], objToSend);
  }
  getStatusNotification(chargeboxId) {
    this.statusSubs = Observable.interval(40000).pipe(startWith(0)).subscribe((val: any) => {
      this.chargeBoxService.isChargeBoxConnected(chargeboxId).subscribe((data: any) => {
        if (data.is_connected) {
          this.statusSubs = this.stationService.getStatusNotification(chargeboxId).subscribe(response => {

            if (response.length > 0) {
              if (this.stationdetail && this.stationdetail.connectors && this.stationdetail.connectors.length > 0 && this.stationdetail.connectors[0].connectors) {
                this.stationdetail.connectors[0].connectors.forEach((element, index: any) => {
                  let contr = response.filter(x => x.connectorId == element.connectorId);
                  this.stationdetail.connectors[0].connectors[index].chargingStatus = contr.length > 0 ? contr[0].status : ConnectorStatus.UNAVAILABLE;
                });
                let connectors = this.stationdetail.connectors[0].connectors;
                let available = connectors.filter(x => x.chargingStatus == "AVAILABLE");
                this.stationdetail['actualVendor'] = response[0].vendorId ? response[0].vendorId : '';
                if (available.length == connectors.length) {
                  this.stationdetail['connectorsStatus'] = ConnectorStatus.AVAILABLE;
                  this.stationdetail['connectorsStatusColor'] = ConnetorColorCodes.GREEN;
                }
                else if (available.length > 0) {
                  this.stationdetail['connectorsStatus'] = ConnectorStatus.PARTIALLY;
                  this.stationdetail['connectorsStatusColor'] = ConnetorColorCodes.ORANGE;
                }
                else {
                  let charging = connectors.filter(x => x.chargingStatus == "CHARGING");
                  if (charging.length == connectors.length) {
                    this.stationdetail['connectorsStatus'] = ConnectorStatus.BUSY;
                    this.stationdetail['connectorsStatusColor'] = ConnetorColorCodes.RED;
                  }
                  else if (charging.length == 0) {
                    this.stationdetail['connectorsStatus'] = ConnectorStatus.UNAVAILABLE;
                    this.stationdetail['connectorsStatusColor'] = ConnetorColorCodes.UNAVBLE;
                  }
                }
              }
            } else {
              !!this.stationdetail.connectors[0] && this.stationdetail.connectors[0].connectors.map(res => {
                res.chargingStatus = ConnectorStatus.UNAVAILABLE;
              });
              this.stationdetail['connectorsStatus'] = ConnectorStatus.UNAVAILABLE;
              this.stationdetail['connectorsStatusColor'] = ConnetorColorCodes.UNAVBLE;
            }
          }, err => {
            !!this.stationdetail.connectors[0] && this.stationdetail.connectors[0].connectors.map(res => {
              res.chargingStatus = ConnectorStatus.UNAVAILABLE;
            });
            this.stationdetail['connectorsStatus'] = ConnectorStatus.UNAVAILABLE;
            this.stationdetail['connectorsStatusColor'] = ConnetorColorCodes.UNAVBLE;
            this.toasterService.error(this.translate.instant('responseFailed'));
          })

        } else {
          this.stationdetail['connectorsStatus'] = ConnectorStatus.UNAVAILABLE;
          this.stationdetail['connectorsStatusColor'] = ConnetorColorCodes.UNAVBLE;
          !!this.stationdetail.connectors[0] && this.stationdetail.connectors[0].connectors.map(res => {
            res.chargingStatus = ConnectorStatus.UNAVAILABLE;
          });
        }
      }, err => {
        this.stationdetail['connectorsStatus'] = 'NA';
        !!this.stationdetail.connectors[0] && this.stationdetail.connectors[0].connectors.map(res => {
          res.chargingStatus = ConnectorStatus.UNAVAILABLE;
        });
      });
    })
  }

  checkPermission(): boolean {
    return this.userInfoService.filterPermission(this.routeID, Permission.UPDATE)
  }

  ngOnDestroy() {
    this.statusSubs.unsubscribe();
  }

  tariffClick(tariffName){
    this.tariffService.getTariffById(tariffName).subscribe(res => {
      this.variableType = res.type;
      this.energyType = res.tariff_detail[0].type
      const commonArray = this.tcolumns = [
        { columnDef: 'type', header: 'tarrif.type', cell: (element: tariffDataDetails) => `${element.subtype}`, sortingDisabled: false, width: 'auto' },
        { columnDef: 'price', header: 'tarrif.price', cell: (element: tariffDataDetails) => `${element.price}`, sortingDisabled: false, width: 'auto' },
        { columnDef: 'start_time', header: 'tarrif.start_time', cell: (element: tariffDataDetails) => `${element.start_time}`, sortingDisabled: false, width: 'auto' },
        { columnDef: 'end_time', header: 'tarrif.end_time', cell: (element: tariffDataDetails) => `${element.end_time}`, sortingDisabled: false, width: 'auto' },
        { columnDef: 'day_of_week', header: 'tarrif.days', cell: (element: tariffDataDetails) => `${element.day_of_week}`, sortingDisabled: false, width: 'auto', isBullet: true },
      ]; if (this.variableType === 'FIXED') {
        if (this.energyType === 'TIME') { commonArray.push({ columnDef: 'step_size', header: 'tarrif.step_size', cell: (element: tariffDataDetails) => `${element.step_size}`, sortingDisabled: false, width: 'auto' }) }
      }
      if (!!res) {
        this.tariffDataDetails = [res];
        let empty = 'NA';
        this.tariffDataDetails['name'] = !res['name'] ? empty : this.capitalizeFirstLetter(res['name']);
        this.tariffDataDetails['vendor_id'] = !res['vendor_id'] ? empty : res['vendor_id'];
        this.tariffDataDetails['currency'] = !res['currency'] ? empty : res['currency'];
        this.tariffDataDetails['country_code'] = !res['country_code'] ? empty : res['country_code'];
        this.tariffDataDetails['type'] = !res['type'] ? empty : res['type'];
        this.tariffTableData = !!res.tariff_detail ? res.tariff_detail : [];
        this.totalDataCountDetail = this.tariffTableData.length
        this.tariffTableData.map((detail: any) => {
          detail.start_time = this.convertTo12HourFormat(detail.start_time);
          detail.end_time = this.convertTo12HourFormat(detail.end_time);
          detail.subtype = detail.type;
          detail.tax = detail.tax;
          detail.price = detail.price;
          detail.step_size = !!detail.step_size ? detail.step_size : 'NA';
          detail.day_of_week = this.sortDaysOfWeek(detail.day_of_week);
        }); this.initialDataId = this.tariffTableData;
        let dialogRef = this.dialog.open(this.viewProfile, {
          height: '500px',
          width: '800px'
        }).afterClosed().subscribe();
      } else {
        this.toastr.error(this.translate.instant('generalTable.noRecord'));
      }
    }, error => {
      this.toastr.error(this.translate.instant('generalTable.noRecord'));
    })
  }

  sortDaysOfWeek(daysOfWeek) {
    const order = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];
    const sortedDaysOfWeek = daysOfWeek.sort((day1, day2) => {
      const index1 = order.indexOf(day1);
      const index2 = order.indexOf(day2);
      return index1 - index2;
    });
    return sortedDaysOfWeek;
  }

  convertTo12HourFormat(timeString: string): string {
    const [hours, minutes] = timeString.split(':');
    const hour = parseInt(hours, 10);
    const period = hour >= 12 ? 'PM' : 'AM';
    const formattedHour = (hour % 12 === 0 ? 12 : hour % 12).toString().padStart(2, '0');
    return `${formattedHour}:${minutes} ${period}`;
  }

  capitalizeFirstLetter(input: string): string {
    return input ? input.charAt(0).toUpperCase() + input.slice(1) : '';
  }
}
